import { InternalAxiosRequestConfig } from 'axios';
import { Role } from '../../types';
import { APP_ROLE_PARAM_KEY } from '../const';

class RolesManipulator {
  static CURRENT_ROLE_STORAGE_KEY = 'vestra_current_user_role';

  sync_params_and_storage_roles(roles: Role[]): void {
    const paramsRole = new URLSearchParams(window.location.search).get(APP_ROLE_PARAM_KEY);
    const isValidRole = Object.values(Role).includes(paramsRole as Role);

    if (!paramsRole || !isValidRole || paramsRole === Role.ACADEMY_USER) return;

    const userHasRole = roles.includes(paramsRole as Role);

    if (isValidRole && userHasRole) {
      this.set_current_user_role(paramsRole);
    }

    // setParams(params => {
    //   params.delete(APP_ROLE_PARAM_KEY);
    //   return params;
    // });
  }

  get current_user_role(): null | Role {
    const searchParams = new URLSearchParams(window.location.search);

    const paramsRole = searchParams.get(APP_ROLE_PARAM_KEY);
    const localStorageRole = localStorage.getItem(RolesManipulator.CURRENT_ROLE_STORAGE_KEY);

    const resolveParamsRole =
      paramsRole && Object.values(Role).includes(paramsRole as Role) ? paramsRole : null;
    const resolveLocalStorageRole =
      localStorageRole && Object.values(Role).includes(localStorageRole as Role)
        ? localStorageRole
        : null;

    return (resolveParamsRole as Role) || (resolveLocalStorageRole as Role);
  }

  set_current_user_role(role: string) {
    localStorage.setItem(RolesManipulator.CURRENT_ROLE_STORAGE_KEY, role);
  }

  apply_app_role_header(config: InternalAxiosRequestConfig) {
    if (this.current_user_role && Object.values(Role).includes(this.current_user_role as Role)) {
      config.headers.set(`x-${APP_ROLE_PARAM_KEY}`, this.current_user_role);
    }
    return config;
  }
}

export const rolesManipulator = new RolesManipulator();
